import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { DateBoxModule } from 'app/shared/components/date-box/date-box.module';
import { InputBoxModule } from 'app/shared/components/input-box/input-box.module';
import { ModalModule } from 'app/shared/components/modal/modal.module';
import { ScrollViewModule } from 'app/shared/components/scroll-view/scroll-view.module';
import { SelectBoxModule } from 'app/shared/components/select-box/select-box.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { TypeUtilizationBoxModule } from '../../../type-utilization-box/type-utilization-box.module';
import { AttributesFilterFormComponent } from './attributes-filter-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ScrollViewModule,
    SelectBoxModule,
    InputBoxModule,
    DateBoxModule,
    ButtonModule,
    ModalModule,
    TypeUtilizationBoxModule,
    PipesModule,
  ],
  declarations: [AttributesFilterFormComponent],
  exports: [AttributesFilterFormComponent],
})
export class AttributesFilterFormModule {}
